module.exports = __webpack_public_path__ + "static/media/monoZ-Logo.4abc33a4.png";